import React from "react";
import { Card, Typography, Space, Row, Col, Progress, Statistic } from "antd";
import { DollarOutlined, BankOutlined } from "@ant-design/icons";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import CustomCard from "../../blocks/Card/Card";

const { Text, Title } = Typography;

const appreciationData = [
  { name: "Property", forecast: 0.19 },
  { name: "Zip Code", forecast: 2.42 },
  { name: "Metro", forecast: 1.7 },
  { name: "County", forecast: 1.77 },
];

const FinancingInvestmentPotential = () => {
  return (
    <CustomCard
      title={
        <Space>
          <DollarOutlined />
          <span>Financing & Investment Potential</span>
        </Space>
      }
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12}>
            <Card>
              <Statistic
                title="Estimated LTV (Loan-to-Value) Ratio"
                value={49}
                suffix="%"
                prefix={<BankOutlined />}
              />
              <Progress percent={49} showInfo={false} strokeColor="#52c41a" />
              <Text type="secondary">
                A 49% LTV ratio suggests significant equity if there's an
                existing mortgage, indicating a strong financial position.
              </Text>
            </Card>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Card>
              <Title level={4}>12-Month Appreciation Forecast</Title>
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={appreciationData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis tickFormatter={(value) => `${value}%`} />
                  <Tooltip formatter={(value) => `${value.toFixed(2)}%`} />
                  <Bar dataKey="forecast" fill="#8884d8" />
                </BarChart>
              </ResponsiveContainer>
              <Text type="secondary">
                Potential for appreciation ranges from 0.19% to 2.42% depending
                on the index used.
              </Text>
            </Card>
          </Col>
        </Row>
        <Card>
          <Title level={4}>Investment Potential Highlights</Title>
          <ul>
            <li>
              <Text strong>Strong Equity Position:</Text> The low LTV ratio
              provides financial flexibility and reduces risk.
            </li>
            <li>
              <Text strong>Appreciation Potential:</Text> Even the most
              conservative forecast suggests positive growth.
            </li>
            <li>
              <Text strong>Market Stability:</Text> The range of forecasts
              indicates a stable market with potential for growth.
            </li>
            <li>
              <Text strong>Refinancing Opportunity:</Text> The significant
              equity could allow for favorable refinancing terms if needed.
            </li>
          </ul>
        </Card>
        <Text type="secondary">
          Note: These projections are based on current market data and
          historical trends. Actual performance may vary. Consult with a
          financial advisor for personalized investment advice.
        </Text>
      </Space>
    </CustomCard>
  );
};

export default FinancingInvestmentPotential;
